
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
<h1>{`Value or Reference`}</h1>
<p>{`When you use a primitive type (also called a scalar value) you always work with its value and they're immutable.`}</p>
<pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const foo = 1;

function myFunc(arg) {
  arg += 1;
  return arg;
}

console.log(myFunc(foo));  // prints 2
console.log(foo);  // prints 1
`}</code></pre>
<p>{`When a complex type is used, a reference to its value is passed instead. Also, they're mutable.`}</p>
<pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const foo = [1, 2, 3, 4];
foo[5] = 5;
console.log(foo);  // prints [1, 2, 3, 4, 5]

function myFunc(arg) {
  arg[0] = 10;
  return arg;
}

console.log(myFunc(foo));  // prints [10, 2, 3, 4, 5];
console.log(foo);  // prints [10, 2, 3, 4, 5];
`}</code></pre>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;